import React from 'react'

const UpdateProduct = () => {
  return (
    <div>
      
    </div>
  )
}

export default UpdateProduct
